<main class="fullscreen-container sign-up">
  <div id="progress" [ngStyle]="{ width: progress+'%'}"></div>
  <!-- add progress percentage to the above div -->
  <ng-container *ngIf="complete">

    <button class="btn btn-outline-light back" routerLink="/home" type="button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path transform="scale(-1,1) translate(-24,0)" class="fill-light"
          d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </svg>

    </button>
    <div class="h-100 w-100 d-flex align-items-center justify-content-center flex-column">
      <div class="inv">
        <div class="letter-image">
          <div class="animated-mail">
            <div class="back-fold"></div>
            <div class="letter">
              <div class="letter-border"></div>
              <div class="letter-title"></div>
              <div class="letter-context"></div>
              <div class="letter-stamp">
                <div class="letter-stamp-inner"></div>
              </div>
            </div>
            <div class="top-fold"></div>
            <div class="body"></div>
            <div class="left-fold"></div>
          </div>
          <div class="en-shadow"></div>
        </div>
      </div>
      <div class="complete-message">
        <h3 translate>signup.CREATE_MESSAGE_TITLE</h3>
        <span translate>signup.CREATE_MESSAGE_SUCCESS</span>
      </div>
    </div>

  </ng-container>
  <form class="h-100" [formGroup]="form" *ngIf="!complete" (ngSubmit)="!this.isLoading && nextStep()"
    (keyup.enter)="!this.isLoading && nextStep()" #formGroupRef="ngForm">

    <button class="btn btn-outline-light back" routerLink="/home" type="button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path transform="scale(-1,1) translate(-24,0)" class="fill-light"
          d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
      </svg>

    </button>

    <div class="h-100 d-flex align-items-center justify-content-center">
      <div class="contents text-center">

        <ng-container [ngSwitch]="currentStep">
          
       
          <div class="signup-content" *ngSwitchCase="SignupSteps.EMAIL_AND_MOBILE">
            <h1 translate>signup.WELCOME_1</h1>
            <p translate>signup.WELCOME_BODY2</p>
            <div class="row-form">
              <div class="signup-content--form">
                <input type="text" id="full_name" formControlName="full_name"required>
                <label for="full_name" translate>signup.FULL_NAME</label>
              </div>
            </div>
           
            <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasEmailError ? 'wrong' : ''">
                <input type="text" id="email" formControlName="email" style="direction: ltr;"  required>
                <label for="email" translate>signup.EMAIL</label>
              </div>
            </div>
            <!-- <div class="row-form">
              <div class="signup-content--form">
                <input type="password" id="password" formControlName="password" #password required>
                <label for="password" translate>signup.PASSWORD</label>
              </div>
            </div>
            <div class="row-form">
              <div class="signup-content--form">
                <input type="password" id="password_confirm" formControlName="password_confirm" #password_confirm required>
                <label for="password_confirm" translate>signup.PASSWORD_CONFIRM</label>
              </div>
            </div> -->
            <ng-container *ngTemplateOutlet="hasEmailErrorTempl"></ng-container>

            <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasMobileError ? 'wrong' : ''">

                <input type="tel" id="mobile" class="mob" formControlName="mobile" style="direction: ltr;" required>
                <label for="mobile" translate>signup.MOBILE</label>
              </div>

              <div class="addon">
              
                <div ngbDropdown >
                  <a class="country-toggle dropdown-toggle" id="countries" ngbDropdownToggle>
                   <img src="{{selectedCountry.flag}}" width="18" height="12" alt="{{selectedCountry.name}}">
                   {{selectedCountry.number}}
                 </a>
                 <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                   <div class=" search-list">
                     <div class="form-group w-100 m-0">
                       <input type="text" class="form-control" placeholder="" #countryAutoCompleteRef (keyup)="onTypeCountryNameOrNumber($event)" required>
                     </div>
                   </div>
                   <ul>
                     <li *ngFor="let country of viewedCountries" class="dropdown-item" (click)="onSelectCountry(country)">
                       <img [src]="country.flag" width="25" height="16.66" [alt]="country.name"> <span class="excerpt">{{country.name}} </span>
                       ({{country.number}})
                     </li>
                   </ul>
                 </div>
               </div>
              </div>

            </div>

            <!-- <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasMobileError ? 'wrong' : ''">
                <input type="tel" id="mobile" class="mob" formControlName="mobile" style="direction: ltr;">
                <label for="mobile" translate>signup.MOBILE</label>
              </div>
              <span class="addon">+966</span>
            </div> -->
            <ng-container *ngTemplateOutlet="hasMobileErrorTempl"></ng-container>
            <ng-container *ngTemplateOutlet="emailValidationTempl"></ng-container>
            <button id="next-step-1"  class="btn btn-light mt-4" (click)="nextStep()"
              [disabled]=" form.controls['email'].invalid || form.controls['mobile'].invalid || form.controls['full_name'].invalid "
              type="button">
              {{'signup.CONTINUE' | translate}}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
                <path d="M0 0h24v24H0z" fill="none" />
                <path class="fill-secondary" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
              </svg>
            </button>
          </div>
          <div class="signup-content" *ngSwitchCase="SignupSteps.REACH_US">
            <h1 translate></h1>
            <h1 translate>{{'signup.WELCOME_NAME' | translate}}، {{form.value.full_name}} </h1>
            <div class="row-form">
              <div class="signup-content--form">
                <div class="row-form">
                  <div class="signup-content--form">
                    <input type="text" id="full_name" formControlName="entity_name"  required>
                    <label for="full_name" translate>signup.Entity_NAME</label>
                  </div>
    
                </div>
                <select name="" formControlName="entity_size" id="entity_size" required>
                  <option value="" disabled selected>حجم الجهة:</option>
                  <option value="10-50">10-50</option>
                  <option value="50-100">50-100</option>
                  <option value="100-500">100-500</option>
                  <option value="500-1000">500-1000</option>
                  <option value=">1000">1000 فأكثر</option>
                </select>
                <select name="" formControlName="target_size" id="target_size" required>
                  <option value="" disabled selected>عدد المتسهدفين من التدريب :</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="100000">100000</option>
                  <option value=">1000000"> مليون متدرب فأكثر</option>
                </select>
                <select name="" formControlName="referred_by" id="referred_by" required>
                  <option value="" disabled selected>وصلت إليكم من خلال:</option>
                  <option value="social_network">وسائل التواصل الإجتماعي</option>
                  <option value="search_engine">محركات البحث</option>
                  <option value="friend">ترشيح صديق</option>
                  <option value="accademy_motawir">أكاديمية مطورة من إلهام</option>
                </select>
              </div>

            </div>
            <div class="row-form">
              <div class="signup-content--form">
                <select name="" formControlName="academy_target" id="academy_target" required>
                  <option value="" disabled selected>استهدف من خلال أكاديميتي:</option>
                  <option value="employee_training">تدريب وتهيئة الموظفين</option>
                  <option value="student_training">تدريب الطلاب</option>
                  <option value="content_publishing_and_selling">نشر وبيع المحتوى</option>
                  <option value="interactive_information_display">عرض المعلومات بطريقة تفاعلية</option>
                </select>
              </div>

            </div>
            <ng-container *ngTemplateOutlet="previousButton"></ng-container>
            <button id="4next-step-2" class="btn btn-light mt-4" (click)="nextStep()"
              [disabled]=" form.controls['referred_by'].invalid || form.controls['academy_target'].invalid || form.controls['entity_name'].invalid || form.controls['entity_size'].invalid  || form.controls['target_size'].invalid"
              type="button">
              {{'signup.CONTINUE' | translate}}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
                <path d="M0 0h24v24H0z" fill="none" />
                <path class="fill-secondary" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
              </svg>
            </button>
          </div>
          <div class="signup-content" *ngSwitchCase="SignupSteps.ACADEMY_INFO">
            <h1 translate>signup.WELCOME_3</h1>
            <p translate>signup.WELCOME_BODY_3</p>


            <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasAlreadyRegisteredError ? 'wrong' : ''">
                <input type="text" id="academy_name" formControlName="title" #academyNameInputRef required>
                <label for="academy_name" translate>signup.ACADEMY_NAME</label>
              </div>
            </div>
            <div class="row-form">
              <span>.xxxx.elham.sa</span>
              <div class="signup-content--form" [ngClass]="hasAlreadyRegisteredError ? 'wrong' : ''">
                  <input type="text" id="academy_url" formControlName="academy_url"  required> 
                  <label for="academy_url" translate>signup.ACADEMY_URL</label>
              </div>
              <span>http://</span>
            </div>
            <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasAlreadyRegisteredError ? 'wrong' : ''">
                <input [(colorPicker)]="primaryColor" [style.background]="primaryColor"/>
                <label for="academy_url" translate>اللون الاساسي</label>
              </div>
            </div>
            <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasAlreadyRegisteredError ? 'wrong' : ''">
                <input [(colorPicker)]="secondaryColor" [style.background]="secondaryColor"/>
                <label for="academy_url" translate>اللون التانوي</label>
              </div>
            </div>
            <div class="row-form">
              <div class="signup-content--form" [ngClass]="hasAlreadyRegisteredError ? 'wrong' : ''">
                <input [(colorPicker)]="textColor" [style.background]="textColor"/>
                <label for="academy_url" translate>لون النص</label>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="hasTitleErrorTempl"></ng-container>
            <ng-container *ngTemplateOutlet="hasAlreadyRegisteredErrorTempl"></ng-container>
            <div class="row-form">
              <div class="signup-content--form select-image" [ngClass]="hasLogoError ? 'wrong' : ''">
                <input type="hidden" name="fileHidden" formControlName="logo" id="logo" />
                <input #logoInput class="customer-logo" style="display: none" hidden="true" id="customer-logo"
                  type="file" (change)="logoInputChange($event)" accept="image/x-png,image/gif,image/jpeg" />
                <button class="upload" (click)="logoInput.click()" type="button">
                  <img alt="upload" [src]="logo">
                  {{'signup.UPLOAD_LOGO' | translate}}
                </button>
              </div>
            </div>
            <div *ngIf="responseErrorMessage" >
              <div class="signup-content--form" class="alert alert-danger">
                <span>{{responseErrorMessage}}</span>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="hasLogoErrorTempl"></ng-container>
            <ng-container *ngTemplateOutlet="previousButton"></ng-container>
            <button [disabled]="form.invalid" class="btn btn-light mt-4" (click)="nextStep()" id="createButton">
              {{'signup.GO' | translate}}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
                <path d="M0 0h24v24H0z" fill="none" />
                <path class="fill-secondary" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
              </svg>
            </button>
   

          </div>

        </ng-container>

        <span class="demo" style="color: #fff;">نسخة تجريبية مجانية</span>
        <a routerLink="/login" class="login">{{'signup.LOGIN' | translate}}</a>
      </div>
      <!-- add class "wrong" to the signup-content div if not success  -->
    </div>

  </form>
</main>
<ng-template #previousButton>
  <button class="btn btn-outline-light mt-4 ms-2" (click)="previousStep()" type="button">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
      <path d="M0 0h24v24H0z" fill="none" />
      <path transform="scale(-1,1) translate(-24,0)" class="fill-light"
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
    </svg>
  </button>
</ng-template>
<ng-template #hasEmailErrorTempl>
  <div *ngIf="hasEmailError" class="alert alert-danger" translate>signup.EMAIL_ALREADY_EXIST</div>
</ng-template>
<ng-template #emailValidationTempl>
  <div class="alert alert-danger" *ngIf="form.get('email') && form.get('email')?.hasError('email')" translate>
    signup.NOT_EMAIL</div>
  <div class="alert alert-danger" *ngIf="form.get('email')?.dirty && form.get('email')?.hasError('required')" translate>
    signup.EMAIL_REQUIRED</div>
</ng-template>
<ng-template #hasMobileErrorTempl>
  <ng-container *ngIf="hasMobileError">
    <div class="alert alert-danger" *ngFor="let error of serverErrors.mobile">
      <svg class="alert-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M12,7a1,1,0,0,1,1,1v4a1,1,0,0,1-2,0V8A1,1,0,0,1,12,7Zm-.01-5A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm1-3H11V15h2Z"
          transform="translate(-2 -2)" />
      </svg> {{error}}</div>
  </ng-container>
</ng-template>
<ng-template #hasLogoErrorTempl>
  <ng-container *ngIf="hasLogoError">
    <div class="alert alert-danger" *ngFor="let error of serverErrors.logo"><svg class="alert-icon"
        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M12,7a1,1,0,0,1,1,1v4a1,1,0,0,1-2,0V8A1,1,0,0,1,12,7Zm-.01-5A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm1-3H11V15h2Z"
          transform="translate(-2 -2)" />
      </svg> {{error}}</div>
  </ng-container>
</ng-template>
<ng-template #hasTitleErrorTempl>
  <ng-container *ngIf="hasTitleError">
    <div class="alert alert-danger" *ngFor="let error of serverErrors.title">
      <svg class="alert-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M12,7a1,1,0,0,1,1,1v4a1,1,0,0,1-2,0V8A1,1,0,0,1,12,7Zm-.01-5A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm1-3H11V15h2Z"
          transform="translate(-2 -2)" />
      </svg> {{error}}</div>
  </ng-container>
</ng-template>
<ng-template #hasAlreadyRegisteredErrorTempl>
  <div class="alert alert-danger" *ngIf="hasAlreadyRegisteredError" translate><svg class="alert-icon"
      xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M12,7a1,1,0,0,1,1,1v4a1,1,0,0,1-2,0V8A1,1,0,0,1,12,7Zm-.01-5A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm1-3H11V15h2Z"
        transform="translate(-2 -2)" />
    </svg> signup.ACCOUNT_ALREADY_EXIST</div>
</ng-template>
